<div class="recurso-pro-item" (click)="planoBasicoCtrl.verificarSeAssinaturaPermiteAcessoAoItem(categoriaItem, slugItem, $event)">
  <ng-content></ng-content>
  {{exibirDescricao ? 'Premium' : ''}}
  <ion-icon *ngIf="exibirIcone" color="primary" name="diamond"></ion-icon>
</div>